import Color from 'color'

export const parse = code => {
    try {
        return Color(code)
    } catch (error) {
        return Color('#000')
    }
}

export const lighten = (code, effect) => parse(code).lighten(effect)

export const darken = (code, effect) => parse(code).darken(effect)

export const fade = (code, effect) => parse(code).fade(effect)

export const opaquer = (code, effect) => parse(code).opaquer(effect)

export const getFocusColor = code => fade(code, 0.6)

export const getHoverColor = code => {
    const color = parse(code)

    return color.isDark() ? lighten(code, 0.1) : darken(code, 0.1)
}

export const getTextColor = code => {
    const color = parse(code)

    return color.isDark() ? lighten(code, 0.75) : darken(code, 0.75)
}
